/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicVerifyPhoneRouteImport } from './routes/_public/verify-phone'
import { Route as PublicVerifyEmailRouteImport } from './routes/_public/verify-email'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicRegisterRouteImport } from './routes/_public/register'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppHelpRouteImport } from './routes/_app/help'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppProductsRouteRouteImport } from './routes/_app/products/route'
import { Route as AppClientsRouteRouteImport } from './routes/_app/clients/route'
import { Route as AppAccountRouteRouteImport } from './routes/_app/account/route'
import { Route as AppSuppliersIndexRouteImport } from './routes/_app/suppliers/index'
import { Route as AppProductsIndexRouteImport } from './routes/_app/products/index'
import { Route as AppInvoicesIndexRouteImport } from './routes/_app/invoices/index'
import { Route as AppDeclarationsIndexRouteImport } from './routes/_app/declarations/index'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients/index'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account/index'
import { Route as AppInvoicesDraftRouteImport } from './routes/_app/invoices/draft'
import { Route as AppInvoicesInvoiceIdRouteImport } from './routes/_app/invoices/$invoiceId'
import { Route as AppClientsSuppliersRouteImport } from './routes/_app/clients/suppliers'
import { Route as AppAccountProfileRouteImport } from './routes/_app/account/profile'
import { Route as AppAccountFiscalRouteImport } from './routes/_app/account/fiscal'
import { Route as AppAccountCertificatesRouteImport } from './routes/_app/account/certificates'
import { Route as AppAccountBrandingRouteImport } from './routes/_app/account/branding'
import { Route as AppAccountBillingRouteImport } from './routes/_app/account/billing'
import { Route as AppInvoicesDraftIndexRouteImport } from './routes/_app/invoices/draft.index'
import { Route as AppInvoicesDraftDraftIdRouteImport } from './routes/_app/invoices/draft.$draftId'
import { Route as AppAccountBillingProcessingRouteImport } from './routes/_app/account_.billing.processing'

const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicVerifyPhoneRoute = PublicVerifyPhoneRouteImport.update({
  id: '/verify-phone',
  path: '/verify-phone',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicVerifyEmailRoute = PublicVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicRegisterRoute = PublicRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRouteRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProductsRouteRoute = AppProductsRouteRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppClientsRouteRoute = AppClientsRouteRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccountRouteRoute = AppAccountRouteRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSuppliersIndexRoute = AppSuppliersIndexRouteImport.update({
  id: '/suppliers/',
  path: '/suppliers/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProductsIndexRoute = AppProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProductsRouteRoute,
} as any)
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDeclarationsIndexRoute = AppDeclarationsIndexRouteImport.update({
  id: '/declarations/',
  path: '/declarations/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppClientsRouteRoute,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppInvoicesDraftRoute = AppInvoicesDraftRouteImport.update({
  id: '/invoices/draft',
  path: '/invoices/draft',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInvoicesInvoiceIdRoute = AppInvoicesInvoiceIdRouteImport.update({
  id: '/invoices/$invoiceId',
  path: '/invoices/$invoiceId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppClientsSuppliersRoute = AppClientsSuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => AppClientsRouteRoute,
} as any)
const AppAccountProfileRoute = AppAccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountFiscalRoute = AppAccountFiscalRouteImport.update({
  id: '/fiscal',
  path: '/fiscal',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountCertificatesRoute = AppAccountCertificatesRouteImport.update({
  id: '/certificates',
  path: '/certificates',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountBrandingRoute = AppAccountBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountBillingRoute = AppAccountBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppInvoicesDraftIndexRoute = AppInvoicesDraftIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInvoicesDraftRoute,
} as any)
const AppInvoicesDraftDraftIdRoute = AppInvoicesDraftDraftIdRouteImport.update({
  id: '/$draftId',
  path: '/$draftId',
  getParentRoute: () => AppInvoicesDraftRoute,
} as any)
const AppAccountBillingProcessingRoute =
  AppAccountBillingProcessingRouteImport.update({
    id: '/account_/billing/processing',
    path: '/account/billing/processing',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AppAccountRouteRouteWithChildren
  '/clients': typeof AppClientsRouteRouteWithChildren
  '/products': typeof AppProductsRouteRouteWithChildren
  '/dashboard': typeof AppDashboardRoute
  '/help': typeof AppHelpRoute
  '/notifications': typeof AppNotificationsRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/register': typeof PublicRegisterRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/verify-email': typeof PublicVerifyEmailRoute
  '/verify-phone': typeof PublicVerifyPhoneRoute
  '/account/billing': typeof AppAccountBillingRoute
  '/account/branding': typeof AppAccountBrandingRoute
  '/account/certificates': typeof AppAccountCertificatesRoute
  '/account/fiscal': typeof AppAccountFiscalRoute
  '/account/profile': typeof AppAccountProfileRoute
  '/clients/suppliers': typeof AppClientsSuppliersRoute
  '/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRoute
  '/invoices/draft': typeof AppInvoicesDraftRouteWithChildren
  '/account/': typeof AppAccountIndexRoute
  '/clients/': typeof AppClientsIndexRoute
  '/declarations/': typeof AppDeclarationsIndexRoute
  '/invoices/': typeof AppInvoicesIndexRoute
  '/products/': typeof AppProductsIndexRoute
  '/suppliers/': typeof AppSuppliersIndexRoute
  '/account/billing/processing': typeof AppAccountBillingProcessingRoute
  '/invoices/draft/$draftId': typeof AppInvoicesDraftDraftIdRoute
  '/invoices/draft/': typeof AppInvoicesDraftIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof AppDashboardRoute
  '/help': typeof AppHelpRoute
  '/notifications': typeof AppNotificationsRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/register': typeof PublicRegisterRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/verify-email': typeof PublicVerifyEmailRoute
  '/verify-phone': typeof PublicVerifyPhoneRoute
  '/account/billing': typeof AppAccountBillingRoute
  '/account/branding': typeof AppAccountBrandingRoute
  '/account/certificates': typeof AppAccountCertificatesRoute
  '/account/fiscal': typeof AppAccountFiscalRoute
  '/account/profile': typeof AppAccountProfileRoute
  '/clients/suppliers': typeof AppClientsSuppliersRoute
  '/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRoute
  '/account': typeof AppAccountIndexRoute
  '/clients': typeof AppClientsIndexRoute
  '/declarations': typeof AppDeclarationsIndexRoute
  '/invoices': typeof AppInvoicesIndexRoute
  '/products': typeof AppProductsIndexRoute
  '/suppliers': typeof AppSuppliersIndexRoute
  '/account/billing/processing': typeof AppAccountBillingProcessingRoute
  '/invoices/draft/$draftId': typeof AppInvoicesDraftDraftIdRoute
  '/invoices/draft': typeof AppInvoicesDraftIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_app/account': typeof AppAccountRouteRouteWithChildren
  '/_app/clients': typeof AppClientsRouteRouteWithChildren
  '/_app/products': typeof AppProductsRouteRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/help': typeof AppHelpRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/register': typeof PublicRegisterRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/verify-email': typeof PublicVerifyEmailRoute
  '/_public/verify-phone': typeof PublicVerifyPhoneRoute
  '/_app/account/billing': typeof AppAccountBillingRoute
  '/_app/account/branding': typeof AppAccountBrandingRoute
  '/_app/account/certificates': typeof AppAccountCertificatesRoute
  '/_app/account/fiscal': typeof AppAccountFiscalRoute
  '/_app/account/profile': typeof AppAccountProfileRoute
  '/_app/clients/suppliers': typeof AppClientsSuppliersRoute
  '/_app/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRoute
  '/_app/invoices/draft': typeof AppInvoicesDraftRouteWithChildren
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/declarations/': typeof AppDeclarationsIndexRoute
  '/_app/invoices/': typeof AppInvoicesIndexRoute
  '/_app/products/': typeof AppProductsIndexRoute
  '/_app/suppliers/': typeof AppSuppliersIndexRoute
  '/_app/account_/billing/processing': typeof AppAccountBillingProcessingRoute
  '/_app/invoices/draft/$draftId': typeof AppInvoicesDraftDraftIdRoute
  '/_app/invoices/draft/': typeof AppInvoicesDraftIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/clients'
    | '/products'
    | '/dashboard'
    | '/help'
    | '/notifications'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/verify-phone'
    | '/account/billing'
    | '/account/branding'
    | '/account/certificates'
    | '/account/fiscal'
    | '/account/profile'
    | '/clients/suppliers'
    | '/invoices/$invoiceId'
    | '/invoices/draft'
    | '/account/'
    | '/clients/'
    | '/declarations/'
    | '/invoices/'
    | '/products/'
    | '/suppliers/'
    | '/account/billing/processing'
    | '/invoices/draft/$draftId'
    | '/invoices/draft/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/help'
    | '/notifications'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/verify-phone'
    | '/account/billing'
    | '/account/branding'
    | '/account/certificates'
    | '/account/fiscal'
    | '/account/profile'
    | '/clients/suppliers'
    | '/invoices/$invoiceId'
    | '/account'
    | '/clients'
    | '/declarations'
    | '/invoices'
    | '/products'
    | '/suppliers'
    | '/account/billing/processing'
    | '/invoices/draft/$draftId'
    | '/invoices/draft'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_public'
    | '/_app/account'
    | '/_app/clients'
    | '/_app/products'
    | '/_app/dashboard'
    | '/_app/help'
    | '/_app/notifications'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/register'
    | '/_public/reset-password'
    | '/_public/verify-email'
    | '/_public/verify-phone'
    | '/_app/account/billing'
    | '/_app/account/branding'
    | '/_app/account/certificates'
    | '/_app/account/fiscal'
    | '/_app/account/profile'
    | '/_app/clients/suppliers'
    | '/_app/invoices/$invoiceId'
    | '/_app/invoices/draft'
    | '/_app/account/'
    | '/_app/clients/'
    | '/_app/declarations/'
    | '/_app/invoices/'
    | '/_app/products/'
    | '/_app/suppliers/'
    | '/_app/account_/billing/processing'
    | '/_app/invoices/draft/$draftId'
    | '/_app/invoices/draft/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/verify-phone': {
      id: '/_public/verify-phone'
      path: '/verify-phone'
      fullPath: '/verify-phone'
      preLoaderRoute: typeof PublicVerifyPhoneRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/verify-email': {
      id: '/_public/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof PublicVerifyEmailRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/register': {
      id: '/_public/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof PublicRegisterRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/help': {
      id: '/_app/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/products': {
      id: '/_app/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/clients': {
      id: '/_app/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/suppliers/': {
      id: '/_app/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof AppSuppliersIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/products/': {
      id: '/_app/products/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof AppProductsIndexRouteImport
      parentRoute: typeof AppProductsRouteRoute
    }
    '/_app/invoices/': {
      id: '/_app/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AppInvoicesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/declarations/': {
      id: '/_app/declarations/'
      path: '/declarations'
      fullPath: '/declarations/'
      preLoaderRoute: typeof AppDeclarationsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppClientsRouteRoute
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/invoices/draft': {
      id: '/_app/invoices/draft'
      path: '/invoices/draft'
      fullPath: '/invoices/draft'
      preLoaderRoute: typeof AppInvoicesDraftRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/invoices/$invoiceId': {
      id: '/_app/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof AppInvoicesInvoiceIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/clients/suppliers': {
      id: '/_app/clients/suppliers'
      path: '/suppliers'
      fullPath: '/clients/suppliers'
      preLoaderRoute: typeof AppClientsSuppliersRouteImport
      parentRoute: typeof AppClientsRouteRoute
    }
    '/_app/account/profile': {
      id: '/_app/account/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AppAccountProfileRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/fiscal': {
      id: '/_app/account/fiscal'
      path: '/fiscal'
      fullPath: '/account/fiscal'
      preLoaderRoute: typeof AppAccountFiscalRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/certificates': {
      id: '/_app/account/certificates'
      path: '/certificates'
      fullPath: '/account/certificates'
      preLoaderRoute: typeof AppAccountCertificatesRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/branding': {
      id: '/_app/account/branding'
      path: '/branding'
      fullPath: '/account/branding'
      preLoaderRoute: typeof AppAccountBrandingRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/billing': {
      id: '/_app/account/billing'
      path: '/billing'
      fullPath: '/account/billing'
      preLoaderRoute: typeof AppAccountBillingRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/invoices/draft/': {
      id: '/_app/invoices/draft/'
      path: '/'
      fullPath: '/invoices/draft/'
      preLoaderRoute: typeof AppInvoicesDraftIndexRouteImport
      parentRoute: typeof AppInvoicesDraftRoute
    }
    '/_app/invoices/draft/$draftId': {
      id: '/_app/invoices/draft/$draftId'
      path: '/$draftId'
      fullPath: '/invoices/draft/$draftId'
      preLoaderRoute: typeof AppInvoicesDraftDraftIdRouteImport
      parentRoute: typeof AppInvoicesDraftRoute
    }
    '/_app/account_/billing/processing': {
      id: '/_app/account_/billing/processing'
      path: '/account/billing/processing'
      fullPath: '/account/billing/processing'
      preLoaderRoute: typeof AppAccountBillingProcessingRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppAccountRouteRouteChildren {
  AppAccountBillingRoute: typeof AppAccountBillingRoute
  AppAccountBrandingRoute: typeof AppAccountBrandingRoute
  AppAccountCertificatesRoute: typeof AppAccountCertificatesRoute
  AppAccountFiscalRoute: typeof AppAccountFiscalRoute
  AppAccountProfileRoute: typeof AppAccountProfileRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
}

const AppAccountRouteRouteChildren: AppAccountRouteRouteChildren = {
  AppAccountBillingRoute: AppAccountBillingRoute,
  AppAccountBrandingRoute: AppAccountBrandingRoute,
  AppAccountCertificatesRoute: AppAccountCertificatesRoute,
  AppAccountFiscalRoute: AppAccountFiscalRoute,
  AppAccountProfileRoute: AppAccountProfileRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
}

const AppAccountRouteRouteWithChildren = AppAccountRouteRoute._addFileChildren(
  AppAccountRouteRouteChildren,
)

interface AppClientsRouteRouteChildren {
  AppClientsSuppliersRoute: typeof AppClientsSuppliersRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
}

const AppClientsRouteRouteChildren: AppClientsRouteRouteChildren = {
  AppClientsSuppliersRoute: AppClientsSuppliersRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
}

const AppClientsRouteRouteWithChildren = AppClientsRouteRoute._addFileChildren(
  AppClientsRouteRouteChildren,
)

interface AppProductsRouteRouteChildren {
  AppProductsIndexRoute: typeof AppProductsIndexRoute
}

const AppProductsRouteRouteChildren: AppProductsRouteRouteChildren = {
  AppProductsIndexRoute: AppProductsIndexRoute,
}

const AppProductsRouteRouteWithChildren =
  AppProductsRouteRoute._addFileChildren(AppProductsRouteRouteChildren)

interface AppInvoicesDraftRouteChildren {
  AppInvoicesDraftDraftIdRoute: typeof AppInvoicesDraftDraftIdRoute
  AppInvoicesDraftIndexRoute: typeof AppInvoicesDraftIndexRoute
}

const AppInvoicesDraftRouteChildren: AppInvoicesDraftRouteChildren = {
  AppInvoicesDraftDraftIdRoute: AppInvoicesDraftDraftIdRoute,
  AppInvoicesDraftIndexRoute: AppInvoicesDraftIndexRoute,
}

const AppInvoicesDraftRouteWithChildren =
  AppInvoicesDraftRoute._addFileChildren(AppInvoicesDraftRouteChildren)

interface AppRouteRouteChildren {
  AppAccountRouteRoute: typeof AppAccountRouteRouteWithChildren
  AppClientsRouteRoute: typeof AppClientsRouteRouteWithChildren
  AppProductsRouteRoute: typeof AppProductsRouteRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRoute
  AppHelpRoute: typeof AppHelpRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppInvoicesInvoiceIdRoute: typeof AppInvoicesInvoiceIdRoute
  AppInvoicesDraftRoute: typeof AppInvoicesDraftRouteWithChildren
  AppDeclarationsIndexRoute: typeof AppDeclarationsIndexRoute
  AppInvoicesIndexRoute: typeof AppInvoicesIndexRoute
  AppSuppliersIndexRoute: typeof AppSuppliersIndexRoute
  AppAccountBillingProcessingRoute: typeof AppAccountBillingProcessingRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAccountRouteRoute: AppAccountRouteRouteWithChildren,
  AppClientsRouteRoute: AppClientsRouteRouteWithChildren,
  AppProductsRouteRoute: AppProductsRouteRouteWithChildren,
  AppDashboardRoute: AppDashboardRoute,
  AppHelpRoute: AppHelpRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppInvoicesInvoiceIdRoute: AppInvoicesInvoiceIdRoute,
  AppInvoicesDraftRoute: AppInvoicesDraftRouteWithChildren,
  AppDeclarationsIndexRoute: AppDeclarationsIndexRoute,
  AppInvoicesIndexRoute: AppInvoicesIndexRoute,
  AppSuppliersIndexRoute: AppSuppliersIndexRoute,
  AppAccountBillingProcessingRoute: AppAccountBillingProcessingRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicRegisterRoute: typeof PublicRegisterRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicVerifyEmailRoute: typeof PublicVerifyEmailRoute
  PublicVerifyPhoneRoute: typeof PublicVerifyPhoneRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicRegisterRoute: PublicRegisterRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicVerifyEmailRoute: PublicVerifyEmailRoute,
  PublicVerifyPhoneRoute: PublicVerifyPhoneRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
